import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import "./Header.css";
import logo from "../images/logo.png";

const navLinks = [
  { to: "/corporate",  label: "Corporate"              },
  { to: "/about-us",   label: "About Us"               },
  { to: "/careers",    label: "Careers"                },
  { to: "/pricing",    label: "Pricing"                },
  { to: "/contact-us", label: "Contact"                },
  { to: "/insights",   label: "Insights"               },
];

const HamburgerIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
    <path d="M2 4h14M2 9h14M2 14h14" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
  </svg>
);

const CloseIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
    <path d="M3 3l12 12M15 3L3 15" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
  </svg>
);

const ExternalArrow = () => (
  <svg width="11" height="11" viewBox="0 0 11 11" fill="none" aria-hidden="true">
    <path d="M1 10L10 1M10 1H3.5M10 1V7.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const ChevronRight = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
    <path d="M5 3l4 4-4 4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Lock body scroll when mobile menu is open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [menuOpen]);

  const close = () => setMenuOpen(false);

  return (
    <>
      <header className={`header${scrolled ? " header--scrolled" : ""}`}>
        <div className="container">

          {/* ── LOGO ── */}
          <NavLink to="/" className="logo" onClick={close}>
            <img src={logo} alt="Mr Truck" className="logo-img" />
            <div className="logo-divider" />
            <div className="logo-text">
              <span className="logo-main">MR</span>
              <span className="logo-accent">TRUCK</span>
            </div>
          </NavLink>

          {/* ── DESKTOP NAV ── */}
          <nav className="nav" aria-label="Main navigation">
            {navLinks.map(({ to, label, end }) => (
              <NavLink
                key={to}
                to={to}
                end={end}
                className={({ isActive }) =>
                  `nav-link${isActive ? " nav-link--active" : ""}`
                }
              >
                {label}
              </NavLink>
            ))}

            <a
              href="https://play.google.com/store/apps/details?id=com.MrTruck"
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link nav-link--driver"
            >
              Become a Driver <ExternalArrow />
            </a>
          </nav>

          {/* ── RIGHT ACTIONS ── */}
          <div className="header-actions">
            <a
              href="https://play.google.com/store/apps/details?id=com.MrTruck"
              target="_blank"
              rel="noopener noreferrer"
              className="cta-btn"
            >
              Book a Truck <ExternalArrow />
            </a>

            <button
              className="menu-toggle"
              onClick={() => setMenuOpen((o) => !o)}
              aria-label={menuOpen ? "Close menu" : "Open menu"}
              aria-expanded={menuOpen}
            >
              {menuOpen ? <CloseIcon /> : <HamburgerIcon />}
            </button>
          </div>
        </div>

        {/* ── MOBILE DRAWER ── */}
        <div
          className={`mobile-menu${menuOpen ? " mobile-menu--open" : ""}`}
          aria-hidden={!menuOpen}
        >
          <div className="mobile-menu-links">
            {navLinks.map(({ to, label, end }) => (
              <NavLink
                key={to}
                to={to}
                end={end}
                onClick={close}
                className={({ isActive }) =>
                  `mobile-menu-link${isActive ? " mobile-menu-link--active" : ""}`
                }
              >
                {label}
                <ChevronRight />
              </NavLink>
            ))}
          </div>

          <div className="mobile-menu-divider" />

          <div className="mobile-menu-footer">
            <a
              href="https://play.google.com/store/apps/details?id=com.MrTruck"
              target="_blank"
              rel="noopener noreferrer"
              className="mobile-cta-primary"
              onClick={close}
            >
              Book a Truck ↗
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.MrTruck"
              target="_blank"
              rel="noopener noreferrer"
              className="mobile-cta-secondary"
              onClick={close}
            >
              Become a Driver ↗
            </a>
          </div>
        </div>
      </header>

      {/* Overlay behind mobile menu */}
      {menuOpen && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(13, 27, 42, 0.38)",
            zIndex: 998,
            backdropFilter: "blur(2px)",
          }}
          onClick={close}
          aria-hidden="true"
        />
      )}
    </>
  );
}
